export default {
  LANGLEVEL_MOEDERTAAL: 'moedertaal',
  LANGLEVEL_UITSTEKEND: 'uitstekend',
  LANGLEVEL_GOED: 'goed',
  LANGLEVEL_REDELIJK: 'redelijk',
  LANGLEVEL_MATIG: 'matig'
}
